var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3239_22281)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6941 7.22664C19.1281 7.4778 18.5201 7.64759 17.8809 7.72391C18.5333 7.33327 19.0331 6.71424 19.269 5.97749C18.6493 6.34555 17.9711 6.60467 17.2639 6.74358C16.6884 6.13009 15.8676 5.74707 14.9596 5.74707C13.2168 5.74707 11.8033 7.15997 11.8033 8.90387C11.8033 9.15095 11.8311 9.39201 11.8846 9.62346C9.26095 9.4916 6.93491 8.23484 5.37796 6.32519C5.1061 6.79158 4.95049 7.33384 4.95049 7.91241C4.95049 9.00748 5.50786 9.97368 6.35479 10.5397C5.85342 10.5241 5.36306 10.3888 4.92469 10.145V10.1849C4.92469 11.7145 6.01268 12.99 7.45692 13.2801C7.19161 13.3527 6.91319 13.3907 6.62515 13.3907C6.42149 13.3907 6.22391 13.3715 6.03089 13.3351C6.43262 14.5889 7.59847 15.5015 8.97947 15.5273C7.89906 16.3742 6.5377 16.8791 5.05912 16.8791C4.80445 16.8791 4.55275 16.8639 4.30566 16.8341C5.70292 17.73 7.36193 18.2531 9.14474 18.2531C14.951 18.2531 18.1265 13.4428 18.1265 9.27128C18.1265 9.13433 18.1235 8.9984 18.1169 8.86296C18.7356 8.41545 19.2697 7.86137 19.6941 7.22664Z",
    fill: "#191919"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3239_22281"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.85c349b5c9d4a5a239ee2b05284ce949.svg";
export { ForwardRef as ReactComponent };